import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const IconButton = styled.button<{ color?: string }>`
  background: transparent;
  border: none;
  padding: 0;

  &:focus {
    box-shadow: unset !important;
  }

  > figure:focus {
    outline: unset !important;
  }

  &:hover {
    opacity: 0.8;
  }

  * {
    color: ${({ color }) => color || '#006bff'};
    fill: ${({ color }) => color || '#006bff'};
  }
`

export const MainButton = styled.button<{ color?: string }>`
  background-color: ${({ color }) => color || '#006bff'};
  border: 2.5px solid ${({ color }) => color || '#006bff'};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  justify-items: center;

  &:focus {
    box-shadow: unset !important;
  }

  > figure:focus {
    outline: unset !important;
  }

  &:hover {
    opacity: 0.8;
  }

  * {
    color: #ffffff;
  }
`

export const Divider = styled.div`
  height: 32px;
  width: 0;
  border: solid #abbed1 1px;
`

export const PositionCounter = styled.span<{ color?: string }>`
  * {
    color: ${({ color }) => color || '#006bff'};
  }
`
